var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF",
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_127339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_127339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2001 26.6665L20.0001 21.8665L24.8001 26.6665L26.6667 24.7998L21.8667 19.9998L26.6667 15.1998L24.8001 13.3332L20.0001 18.1332L15.2001 13.3332L13.3334 15.1998L18.1334 19.9998L13.3334 24.7998L15.2001 26.6665ZM20.0001 33.3332C18.1556 33.3332 16.4223 32.9832 14.8001 32.2832C13.1779 31.5832 11.7667 30.6332 10.5667 29.4332C9.36675 28.2332 8.41675 26.8221 7.71675 25.1998C7.01675 23.5776 6.66675 21.8443 6.66675 19.9998C6.66675 18.1554 7.01675 16.4221 7.71675 14.7998C8.41675 13.1776 9.36675 11.7665 10.5667 10.5665C11.7667 9.3665 13.1779 8.4165 14.8001 7.7165C16.4223 7.0165 18.1556 6.6665 20.0001 6.6665C21.8445 6.6665 23.5779 7.0165 25.2001 7.7165C26.8223 8.4165 28.2334 9.3665 29.4334 10.5665C30.6334 11.7665 31.5834 13.1776 32.2834 14.7998C32.9834 16.4221 33.3334 18.1554 33.3334 19.9998C33.3334 21.8443 32.9834 23.5776 32.2834 25.1998C31.5834 26.8221 30.6334 28.2332 29.4334 29.4332C28.2334 30.6332 26.8223 31.5832 25.2001 32.2832C23.5779 32.9832 21.8445 33.3332 20.0001 33.3332ZM20.0001 30.6665C22.9779 30.6665 25.5001 29.6332 27.5667 27.5665C29.6334 25.4998 30.6667 22.9776 30.6667 19.9998C30.6667 17.0221 29.6334 14.4998 27.5667 12.4332C25.5001 10.3665 22.9779 9.33317 20.0001 9.33317C17.0223 9.33317 14.5001 10.3665 12.4334 12.4332C10.3667 14.4998 9.33341 17.0221 9.33341 19.9998C9.33341 22.9776 10.3667 25.4998 12.4334 27.5665C14.5001 29.6332 17.0223 30.6665 20.0001 30.6665Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCancellation);
export default __webpack_public_path__ + "static/media/ActiveCancellation.898f01a9cd8b1b9742b147a7b0b6c8a2.svg";
export { ForwardRef as ReactComponent };